import { memo, useContext } from 'react';
import { StepViewComponentProps } from '../stepDescriptor/types';
import TextCollectionTaskComponent from './TextCollectionTaskComponent';
import FormTaskComponent from './FormTaskComponent';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';
import { ChatTaskContext } from '../../contexts/ChatTaskContext';

function TextCollectionViewComponent(props: StepViewComponentProps) {
  const taskContext = useContext(ChatTaskContext);
  const isNewFormEnabled = useUnleashFeatureFlag(
    'chat-enable-form-task-component',
    {
      projectId: taskContext.projectId,
    },
    false,
  );

  if (isNewFormEnabled) {
    return <FormTaskComponent {...props} isPinnable isPinnedView={false} />;
  }
  return <TextCollectionTaskComponent {...props} isPinnable isPinnedView={false} />;
}

export default memo(TextCollectionViewComponent);
